export enum UserInteractionEventName {
  templateLoadingScreenViewed = "template_loading_screen_viewed",
  templateCardClicked = "template_card_clicked",
  templatesFiltered = "templates_filtered",
  templateAppFilterCleared = "template_app_filter_cleared",
  templateAppFilterUpdated = "template_app_filter_updated",
  templateUseCaseFilterUpdated = "template_use_case_filter_updated",
  templateUseCaseFilterCleared = "template_use_case_filter_cleared",
  templateAllFiltersCleared = "template_all_filters_cleared",
  templatesSearched = "templates_searched",
  templateDetailModalViewed = "template_detail_modal_viewed",
  templateDetailCreateClicked = "template_detail_create_clicked",
  templateShowcaseTabClicked = "template_showcase_tab_clicked",
  templateDetailShareButtonClicked = "template_detail_share_button_clicked",
  templateBookmarkButtonClicked = "template_bookmark_button_clicked",
}

export const UserInteractionEvent =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";

// constants for ZapEntryPointEvent and ZapCreationRequestSuccessEvent in
// the service or as query params via webintent
export const ENTRY_POINT_METHOD_QUERY_PARAM = "entry-point-method";
export const ENTRY_POINT_LOCATION_QUERY_PARAM = "entry-point-location";
export const ENTRY_POINT_METHOD = "zap_template";
export const ENTRY_POINT_LOCATION = "templates_home";
